// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-TeamSection-module--cls1--3keLv","cls2":"styles-TeamSection-module--cls2--2W0Sd styles-TeamSection-module--cls1--3keLv"};